import React, { useState } from 'react';

/**
 * Props for {@link MovedFromDot}.
 */
interface MovedFromDotProps {
  /** The record type this event was moved from (e.g. 'Planned'). */
  fromRecordType: string;
}

/**
 * Blue lineage dot shown on a record that was created by moving another record
 * here. Hovering the dot reveals a tooltip stating which record type the event
 * was moved from; the tooltip closes as soon as the cursor leaves the dot.
 */
const MovedFromDot: React.FC<MovedFromDotProps> = ({ fromRecordType }) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const message = `Moved from '${fromRecordType}'`;

  return (
    <span
      className="moved-from-dot-wrap"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="moved-from-dot" aria-label={message} role="img" />
      {hovered && (
        <span className="moved-from-tooltip" role="tooltip">
          {message}
        </span>
      )}
    </span>
  );
};

export default MovedFromDot;
